import React from "react";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { useBoolean } from "../../../../Hooks/useBoolean";
import * as XLSX from "xlsx";

import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { useDispatch } from "react-redux";
import { tripMasterReportAsync } from "../../../../redux/features/reportSlice";
import moment from "moment";
import {
   calculateFormattedTimeDifference,
   calculateTimeDifference,
} from "../../../../helpers/calculateTimeDifference";
import { calculateNumberDifference } from "../../../../helpers/calculateNumberDifference copy";
import { calculateFieldValueSum } from "../../../../helpers/getTripExtrasFieldSum";
import { areAllNumbers, subtractNumbers } from "../../../../helpers";

const AdhocTripReport = () => {
   const dispatch = useDispatch();
   const reportPopup = useBoolean();

   const handleDownloadReport = (data, callback) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         tripMasterReportAsync({
            data: data,
            params: { ...(data?.customerId && { customer_id: data?.customerId }) },
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Vehicle No.",
                  "Vehicle Category",
                  "Trip Created By",
                  "Entry Date",
                  "Driver Name",
                  "Driver No.",
                  "Customer Name",
                  "Origin Company Name",
                  "Origin Address",
                  "Destination Company Name",
                  "Destination Address",
                  "Lane Name",
                  "Vehicle Reported Date Time (Origin)",
                  "Vehicle Dispatch Date Time (Origin)",
                  "Invoice No.",
                  "Invoice Date",
                  "Invoice Value",
                  "E Waybill No.",
                  "E Waybill Expiry Date & Time",
                  "Customer / Eisaku LR No.",
                  "LR Date",
                  "Destination Reported Date Time",
                  "Destination Unloading Date Time",
                  "TAT (in Hrs)",
                  "Holding Time at Origin",
                  "Holding Time at Destination",
                  "POD Received Date",
                  "POD Submit Date",
                  "Driver Trip Advance Budget",
                  "Actual Driver Trip Advance",
                  "Driver Trip Advance Variance (Actual - Budget)",
                  "Extra Driver Tip",
                  "Trip Diesel Budget (ltr)",
                  "Actual Diesel Provided",
                  "Trip Diesel Variance (Actual - Budget)",
                  "Extra Trip Diesel",
                  "AdBlue Budget",
                  "Actual AdBlue Provided",
                  "Trip AdBlue Variance (Actual - Budget)",
                  "Extra Adblue",
                  "Actual Miscellaneous Expense (1,2,3… Multiple Addition Required)",
                  "Total Actual Miscellaneous Expense (1+2+3…)",
                  "Budget Trip Toll",
                  "From Customer Trip Rate",
                  "Miscellaneous Charges",
               ];

               const adhocTripMasterDataArr = [];

               let adhocTripMasterId = null;

               let adhocTripMasterMaxSubArrLength = 0;

               const formatDate = (date, withTime = false) =>
                  date
                     ? moment(date).format(
                          withTime ? "DD-MM-YYYY HH:mm:ss" : "DD-MM-YYYY"
                       )
                     : "-";

               report?.adhocTripMaster?.forEach?.((item, index) => {
                  const arr = [];

                  arr.push(
                     adhocTripMasterId === item?.id
                        ? "-"
                        : `${(report?.tripMaster?.length ?? 0) + index + 1}`, // S. No.
                     item?.fleet_master?.vehicle_no ?? "-", // Vehicle No.
                     item?.fleet_master?.vehicle_category?.category_name ?? "-", // Vehicle Category
                     item?.created_by?.name,
                     item?.created_at
                        ? moment(item?.created_at)?.format("DD-MM-YYYY h:mm:ss a")
                        : "-",
                     item?.driver_master?.name ?? "-", // Driver Name
                     item?.driver_master?.mobile ?? "-", // Driver No.
                     item?.adhoc_lane_masters?.customername ?? "-", // Customer Name
                     item?.adhoc_lane_masters?.material_customer_name_origin ?? "-", // Origin Company Name
                     item?.adhoc_lane_masters?.origin_location_master?.name ?? "-", // Origin Address
                     item?.adhoc_lane_masters?.material_customer_name_destination ??
                        "-" ??
                        "-", // Destination Company Name
                     item?.adhoc_lane_masters?.destination_location_master?.name ?? "-", // Destination Address
                     item?.adhoc_lane_masters?.lane_name ?? "-", // Lane Name
                     formatDate(item?.vehicle_reported_date, true), // Vehicle Reported Date Time (Origin)
                     formatDate(item?.vehicle_disptch_date, true), // Vehicle Dispatch Date Time (Origin)
                     item?.invoice_no ?? "-", // Invoice No.
                     formatDate(item?.invoice_date, true), // Invoice Date
                     item?.invoice_value ?? "-", // Invoice Value
                     item?.ewaybillno ?? "-", // E Waybill No.
                     formatDate(item?.ewaybill_expiry_date, true), // E Waybill Expiry Date & Time

                     item?.customer_lrno ?? "-", // Customer / Eisaku LR No.
                     formatDate(item?.created_at), // LR Date
                     formatDate(item?.destination_reported_date, true), // Destination Reported Date Time
                     formatDate(item?.destination_unloading_date, true), // Destination Unloading Date Time

                     item?.trip_status === "closed"
                        ? calculateFormattedTimeDifference(
                             item?.destination_reported_date,
                             item?.vehicle_disptch_date
                          )
                        : "-", // TAT (in Hrs) (Destination Reported date time - Vehicle disptch date time (Origin))

                     calculateFormattedTimeDifference(
                        item?.vehicle_disptch_date,
                        item?.vehicle_reported_date
                     ) ?? "-", // Holding Time at Origin

                     calculateFormattedTimeDifference(
                        item?.destination_unloading_date,
                        item?.destination_reported_date
                     ) ?? "-", // Holding Time at Destination
                     item?.trip_status === "closed"
                        ? formatDate(item?.trip_updated_at)
                        : "", // POD Received Date
                     formatDate(item?.created_at), // POD Submit Date
                     item?.adhoc_lane_masters?.trip_advance ?? "-", // Driver Trip Advance Budget
                     item?.actual_driver_trip_advance ?? "-", // Actual Driver Trip Advance
                     areAllNumbers(
                        item?.adhoc_lane_masters?.trip_advance,
                        item?.actual_driver_trip_advance
                     )
                        ? subtractNumbers(
                             item?.adhoc_lane_masters?.trip_advance,
                             item?.actual_driver_trip_advance
                          )
                        : "-", // Driver Trip Advance Variance (Actual - Budget)
                     "-",
                     item?.adhoc_lane_masters?.tripdiesel_budget ?? "-", // Trip Diesel Budget (ltr)
                     item?.actual_diesel_provided ?? "-", // Actual Diesel Provided
                     areAllNumbers(
                        item?.adhoc_lane_masters?.tripdiesel_budget,
                        item?.actual_diesel_provided
                     )
                        ? subtractNumbers(
                             item?.adhoc_lane_masters?.tripdiesel_budget,
                             item?.actual_diesel_provided
                          )
                        : "-", // Trip Diesel Variance (Actual - Budget)
                     "-",
                     item?.adhoc_lane_masters?.trip_adblue_budget ?? "-", // AdBlue Budget
                     item?.actual_adblue_provided ?? "-", // Actual AdBlue Provided
                     areAllNumbers(
                        item?.adhoc_lane_masters?.adhoc_lane_masters,
                        item?.actual_adblue_provided
                     )
                        ? subtractNumbers(
                             item?.adhoc_lane_masters?.adhoc_lane_masters,
                             item?.actual_adblue_provided
                          )
                        : "-", // Trip AdBlue Variance (Actual - Budget)
                     "-",
                     item?.extras?.[0]?.field_value ?? "-", // Actual Miscellaneous Expense (1,2,3… Multiple Addition Required)
                     calculateFieldValueSum(item?.extras) ?? "-", // Total Actual Miscellaneous Expense (1+2+3…)
                     item?.adhoc_lane_masters?.trip_toll ?? "-", // Budget Trip Toll
                     // item?.trip_toll ?? "-", // Actual Trip Toll
                     // item?.sss ?? "-", // Trip Toll Variance (Actual - Budget)
                     item?.adhoc_lane_masters?.rate ?? "-", // From Customer Trip Rate
                     // item?.vend_trip_rate ?? "-", // From Vendor Trip Rate
                     // item?.cust_express_mode_rate_additional ?? "-", // Express Mode Rate Additional
                     // item?.cust_super_express_mode_rate_additional ?? "-", // Super Express Mode Rate Additional
                     // item?.cust_detention_rate_additional ?? "-", // Detention Rate Additional
                     // item?.cust_multiple_loading_location_rate_additional ?? "-", // Multiple Loading Location Rate Additional
                     // item?.cust_multiple_unloading_location_rate_additional ?? "-", // Multiple Unloading Location Rate Additional
                     // item?.cust_loading_charges ?? "-", // Loading Charges
                     // item?.cust_unloading_charge ?? "-", // Unloading Charge
                     item?.actual_miscellaneous_expense ?? "-" // Miscellaneous Charges
                     // item?.cust_miscellaneous_remarks ?? "-", // Miscellaneous Remarks
                     // item?.vend_express_mode_rate_additional ?? "-", // Express Mode Rate Additional (Vendor)
                     // item?.vend_super_express_mode_rate_additional ?? "-", // Super Express Mode Rate Additional (Vendor)
                     // item?.vend_detention_rate_additional ?? "-", // Detention Rate Additional (Vendor)
                     // item?.vend_multiple_loading_location_rate_additional ?? "-", // Multiple Loading Location Rate Additional (Vendor)
                     // item?.vend_multiple_unloading_location_rate_additional ?? "-", // Multiple Unloading Location Rate Additional (Vendor)
                     // item?.vend_loading_charges ?? "-", // Loading Charges (Vendor)
                     // item?.vend_unloading_charge ?? "-", // Unloading Charge (Vendor)
                     // item?.vend_miscellaneous_charges ?? "-", // Miscellaneous Charges (Vendor)
                     // item?.vend_miscellaneous_remarks ?? "-" // Miscellaneous Remarks (Vendor)
                  );
                  adhocTripMasterId = item?.id;
                  adhocTripMasterDataArr.push(arr);
               });

               const sheetData = [headers, ...adhocTripMasterDataArr];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);
               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "MIS_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               callback?.();
               reportPopup.onFalse();
            },
         })
      );
   };

   //    const handleDownloadReport2 = (data, callback) => {
   //       dispatch(backdropLoadingAction(true));

   //       dispatch(
   //          tripMasterReportAsync({
   //             data: data,
   //             params: { ...(data?.customerId && { customer_id: data?.customerId }) },
   //             err: () => {
   //                dispatch(backdropLoadingAction(false));
   //             },
   //             done: (report) => {
   //                const headers = [
   //                   "S. No.",
   //                   "Vehicle No.",
   //                   "Vehicle Category",
   //                   "Trip Created By",
   //                   "Entry Date",
   //                   "Driver Name",
   //                   "Driver No.",
   //                   "Customer Name",
   //                   // "Origin Company Name",
   //                   "Origin Address",
   //                   // "Destination Company Name",
   //                   "Destination Address",
   //                   "Lane Name",
   //                   "Vehicle Reported Date Time (Origin)",
   //                   "Vehicle Dispatch Date Time (Origin)",
   //                   "Invoice No.",
   //                   "Invoice Date",
   //                   "Invoice Value",
   //                   "E Waybill No.",
   //                   "E Waybill Expiry Date & Time",
   //                   "Customer / Eisaku LR No.",
   //                   "LR Date",
   //                   "Destination Reported Date Time",
   //                   "Destination Unloading Date Time",
   //                   "TAT (in Hrs)",
   //                   "Holding Time at Origin",
   //                   "Holding Time at Destination",
   //                   "POD Received Date",
   //                   "POD Submit Date",
   //                   "Driver Trip Advance Budget",
   //                   "Actual Driver Trip Advance",
   //                   "Driver Trip Advance Variance (Actual - Budget)",
   //                   "Extra Driver Tip",
   //                   "Trip Diesel Budget (ltr)",
   //                   "Actual Diesel Provided",
   //                   "Trip Diesel Variance (Actual - Budget)",
   //                   "Extra Trip Diesel",
   //                   "AdBlue Budget",
   //                   "Actual AdBlue Provided",
   //                   "Trip AdBlue Variance (Actual - Budget)",
   //                   "Extra Adblue",
   //                   "Actual Miscellaneous Expense (1,2,3… Multiple Addition Required)",
   //                   "Total Actual Miscellaneous Expense (1+2+3…)",
   //                   "Extra Miscellaneous Charges",
   //                   "Budget Trip Toll",
   //                   // "Actual Trip Toll",
   //                   // "Trip Toll Variance (Actual - Budget)",
   //                   "From Customer Trip Rate",
   //                   "From Vendor Trip Rate",
   //                   "Express Mode Rate Additional",
   //                   "Super Express Mode Rate Additional",
   //                   "Detention Rate Additional",
   //                   "Multiple Loading Location Rate Additional",
   //                   "Multiple Unloading Location Rate Additional",
   //                   "Loading Charges",
   //                   "Unloading Charge",
   //                   "Miscellaneous Charges",
   //                   "Miscellaneous Remarks",
   //                   "",
   //                   "",
   //                   "",
   //                   "",
   //                   "",
   //                   "",
   //                   "",
   //                   "",
   //                   "",
   //                ];

   //                const formatDate = (date, withTime = false) =>
   //                   date
   //                      ? moment(date).format(
   //                           withTime ? "DD-MM-YYYY HH:mm:ss" : "DD-MM-YYYY"
   //                        )
   //                      : "-";

   //                const tripMasterDataArr = [];

   //                report?.tripMaster?.forEach?.((item, index) => {
   //                   const arr = [];

   //                   arr.push(
   //                      `${index + 1} ${
   //                         item?.review_status === "rejected" ? " (Rejected)" : ""
   //                      }`, // S. No.
   //                      item?.vehicle_no ?? "-", // Vehicle No.
   //                      item?.vehicle_category_name ?? "-", // Vehicle Category
   //                      item?.created_by_name ?? "-", // Trip Created By
   //                      formatDate(item?.trip_created_at, true), // Entry Date
   //                      item?.drivername ?? "-", // Driver Name
   //                      item?.driverno ?? "-", // Driver No.
   //                      item?.customername ?? "-", // Customer Name
   //                      // item?.origin_company_name ?? "-", // Origin Company Name
   //                      item?.lane_masters?.origin_location_master?.name ?? "-", // Origin Address
   //                      // item?.destination_company_name ?? "-", // Destination Company Name
   //                      item?.lane_masters?.destination_location_master?.name ?? "-", // Destination Address
   //                      item?.lane_masters?.name ?? "-", // Lane Name
   //                      formatDate(item?.vehicle_reported_date, true), // Vehicle Reported Date Time (Origin)
   //                      formatDate(item?.vehicle_disptch_date, true), // Vehicle Dispatch Date Time (Origin)
   //                      item?.invoice_no ?? "-", // Invoice No.
   //                      formatDate(item?.invoice_date, true), // Invoice Date
   //                      item?.invoice_value ?? "-", // Invoice Value
   //                      item?.ewaybillno ?? "-", // E Waybill No.
   //                      formatDate(item?.ewaybill_expiry_date, true), // E Waybill Expiry Date & Time
   //                      item?.customer_lrno ?? "-", // Customer / Eisaku LR No.
   //                      formatDate(item?.trip_created_at), // LR Date
   //                      formatDate(item?.destination_reported_date, true), // Destination Reported Date Time
   //                      formatDate(item?.destination_unloading_date, true), // Destination Unloading Date Time
   //                      item?.trip_status === "closed"
   //                         ? Math.abs(
   //                              calculateTimeDifference(
   //                                 item?.destination_reported_date,
   //                                 item?.vehicle_disptch_date
   //                              )
   //                           )
   //                         : "-", // TAT (in Hrs)
   //                      Math.abs(
   //                         calculateTimeDifference(
   //                            item?.vehicle_disptch_date,
   //                            item?.vehicle_reported_date
   //                         )
   //                      ) ?? "-", // Holding Time at Origin
   //                      Math.abs(
   //                         calculateTimeDifference(
   //                            item?.destination_unloading_date,
   //                            item?.destination_reported_date
   //                         )
   //                      ) ?? "-", // Holding Time at Destination
   //                      item?.trip_status === "closed"
   //                         ? formatDate(item?.trip_updated_at)
   //                         : "", // POD Received Date
   //                      formatDate(item?.trip_created_at), // POD Submit Date
   //                      item?.lane_masters?.trip_advance ?? "-", // Driver Trip Advance Budget
   //                      item?.actual_driver_trip_advance ?? "-", // Actual Driver Trip
   //                      areAllNumbers(
   //                         item?.lane_masters?.trip_advance,
   //                         item?.actual_driver_trip_advance
   //                      )
   //                         ? subtractNumbers(
   //                              item?.lane_masters?.trip_advance,
   //                              item?.actual_driver_trip_advance
   //                           )
   //                         : "-", // Driver Trip Advance Variance (Actual - Budget)
   //                      "-",
   //                      item?.lane_masters?.diesel_rate ?? "-", // Trip Diesel Budget (ltr)
   //                      item?.actual_diesel_provided ?? "-", // Actual Diesel Provided
   //                      areAllNumbers(
   //                         item?.lane_masters?.diesel_rate,
   //                         item?.actual_diesel_provided
   //                      )
   //                         ? subtractNumbers(
   //                              item?.lane_masters?.diesel_rate,
   //                              item?.actual_diesel_provided
   //                           )
   //                         : "-", // Trip Diesel Variance (Actual - Budget)
   //                      "-",
   //                      item?.adblue_rate ?? "-", // AdBlue Budget
   //                      item?.actual_adblue_provided ?? "-", // Actual AdBlue Provided
   //                      areAllNumbers(
   //                         item?.lane_masters?.adblue_rate,
   //                         item?.actual_adblue_provided
   //                      )
   //                         ? subtractNumbers(
   //                              item?.lane_masters?.adblue_rate,
   //                              item?.actual_adblue_provided
   //                           )
   //                         : "-", // Trip AdBlue Variance (Actual - Budget)
   //                      "-",
   //                      item?.extras?.[0]?.field_value ?? "-", // Actual Miscellaneous Expense
   //                      calculateFieldValueSum(item?.extras) ?? "-", // Total Miscellaneous Expense
   //                      "-",
   //                      item?.trip_toll_budget ?? "-", // Budget Trip Toll
   //                      // item?.trip_toll ?? "-", // Actual Trip Toll
   //                      // item?.sss ?? "-", // Trip Toll Variance
   //                      item?.cust_trip_rate ?? "-", // From Customer Trip Rate
   //                      item?.vend_trip_rate ?? "-", // From Vendor Trip Rate
   //                      item?.cust_express_mode_rate_additional ?? "-", // Express Mode Rate Additional
   //                      item?.cust_super_express_mode_rate_additional ?? "-", // Super Express Mode Rate Additional
   //                      areAllNumbers(
   //                         Math.abs(
   //                            calculateTimeDifference(
   //                               item?.destination_unloading_date,
   //                               item?.destination_reported_date
   //                            )
   //                         )
   //                      )
   //                         ? calculateDetentionRate(
   //                              Math.abs(
   //                                 calculateTimeDifference(
   //                                    item?.destination_unloading_date,
   //                                    item?.destination_reported_date
   //                                 )
   //                              )
   //                           )
   //                         : "-", // Detention Rate Additional
   //                      item?.cust_multiple_loading_location_rate_additional ?? "-", // Multiple Loading Location Rate Additional
   //                      item?.cust_multiple_unloading_location_rate_additional ?? "-", // Multiple Unloading Location Rate Additional
   //                      item?.cust_loading_charges ?? "-", // Loading Charges
   //                      item?.cust_unloading_charge ?? "-", // Unloading Charge
   //                      item?.cust_miscellaneous_charges ?? "-", // Miscellaneous Charges
   //                      item?.cust_miscellaneous_remarks ?? "-" // Miscellaneous Remarks
   //                   );

   //                   tripMasterDataArr.push(arr);
   //                });

   //                const sheetData = [
   //                   headers,
   //                   ...tripMasterDataArr,
   //                   // lineBreak,
   //                   // ...adhocTripMasterDataArr,
   //                ];

   //                console.log({ report });
   //                const ws = XLSX.utils.aoa_to_sheet(sheetData);
   //                const wb = XLSX.utils.book_new();
   //                XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
   //                XLSX.writeFile(wb, "MIS_REPORT.xlsx");
   //                dispatch(backdropLoadingAction(false));
   //                callback?.();
   //                reportPopup.onFalse();
   //             },
   //          })
   //       );
   //    };

   return (
      <DownloadReportButton
         onDownloadReport={handleDownloadReport}
         confirmPopup={reportPopup}
         //  needCustomerFilter={true}
      />
   );
};

export default AdhocTripReport;
